export type EducationLevel = 'HIGH_SCHOOL' | 'ASSOCIATE' | 'BACHELOR' | 'MASTER' | 'PHD';

export interface Education {
  id: string;
  candidateId: string;
  educationLevel: EducationLevel;
  institution: string;
  educationField: string;
  city: string;
  country: string;
  yearBegin: number;
  yearEnd?: number | null;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEducationRequest {
  educationLevel: EducationLevel;
  institution: string;
  educationField: string;
  city: string;
  country: string;
  yearBegin: number;
  yearEnd?: number | null;
}

export interface UpdateEducationRequest {
  educationLevel?: EducationLevel;
  institution?: string;
  educationField?: string;
  city?: string;
  country?: string;
  yearBegin?: number;
  yearEnd?: number | null;
}

export const EDUCATION_LEVEL_LABELS: Record<EducationLevel, string> = {
  HIGH_SCHOOL: 'High School',
  ASSOCIATE: 'Associate',
  BACHELOR: 'Bachelor',
  MASTER: 'Master',
  PHD: 'PhD',
};
